import { AspectRatio, Heading, Stack, StackProps } from "@biblioteksentralen/react";
import { KulturfondVideo as KulturfondVideoT } from "@libry-content/types";
import { useTranslation } from "../../../utils/hooks/useTranslation";

type Props = { kulturFondVideo?: KulturfondVideoT } & StackProps;

export const KulturfondVideoView = ({ kulturFondVideo, ...stackProps }: Props) => {
  const { t } = useTranslation();
  if (!kulturFondVideo) return null;

  return (
    <Stack maxWidth="35rem" {...stackProps}>
      <Heading as="h2" fontSize="xl">
        {t("Se {name} fra {libraryName} fortelle om boka", {
          name: kulturFondVideo.presenter,
          libraryName: kulturFondVideo.libraryName,
        })}
      </Heading>
      <AspectRatio ratio={16 / 9} borderRadius="xl" overflow="hidden">
        <iframe
          src={kulturFondVideo.videoUrl}
          title={t("Videoavspiller")}
          frameBorder={0}
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      </AspectRatio>
    </Stack>
  );
};
